module.exports = __webpack_public_path__ + "static/media/archive.d526304a.svg";